// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/avenir);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-button {
  position: fixed;
  bottom: 100px;
  right: 20px;
  background: #2c3e50;
  border: none;
  border-radius: 100px;
  padding: 8px 24px 8px 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9997;
  font-family: "Inter", sans-serif;
  min-width: 200px;
  display: block;
  font-size: 16px;
  font-weight: 600;
}
.chat-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  background: #34495e;
}
.chat-button:active {
  transform: translateY(0);
}
.chat-button .button-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
.chat-button .avatar-container-chat-button {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background: white;
}
.chat-button .avatar-container-chat-button .avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.chat-button .avatar-container-chat-button .status-badge {
  position: absolute;
  bottom: -2px;
  right: -2px;
  background-color: #28a745;
  border: 2px solid #2c3e50;
  border-radius: 10px;
  padding: 1px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.chat-button .avatar-container-chat-button .status-badge span {
  color: white;
  font-size: 8px;
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 1;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.chat-button .button-text {
  color: white;
  font-size: 15px;
  font-weight: 700;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .chat-button {
    bottom: 130px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 130px);
    padding: 10px 24px 10px 10px;
  }
  .chat-button:hover {
    transform: translateX(-50%) translateY(-2px);
  }
  .chat-button:active {
    transform: translateX(-50%) translateY(0);
  }
  .chat-button .avatar-container {
    width: 36px;
    height: 36px;
  }
  .chat-button .button-text {
    font-size: 14px;
    font-weight: 700;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/chat-button/chat-button.scss"],"names":[],"mappings":"AAEA;EACC,eAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;EACA,0CAAA;EACA,aAAA;EACA,gCAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACD;AACC;EACC,2BAAA;EACA,yCAAA;EACA,mBAAA;AACF;AAEC;EACC,wBAAA;AAAF;AAGC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AADF;AAIC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAFF;AAIE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAFH;AAKE;EACC,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;AAHH;AAKG;EACC,YAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,yCAAA;AAHJ;AAQC;EACC,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AANF;;AAUA;EACC;IACC,aAAA;IACA,SAAA;IACA,2BAAA;IACA,yBAAA;IAEA,4BAAA;EARA;EAUA;IACC,4CAAA;EARD;EAWA;IACC,yCAAA;EATD;EAYA;IACC,WAAA;IACA,YAAA;EAVD;EAaA;IACC,eAAA;IACA,gBAAA;EAXD;AACF","sourcesContent":["@use \"../../styles/variables\" as *;\n\n.chat-button {\n\tposition: fixed;\n\tbottom: 100px;\n\tright: 20px;\n\tbackground: #2c3e50;\n\tborder: none;\n\tborder-radius: 100px;\n\tpadding: 8px 24px 8px 8px;\n\tcursor: pointer;\n\ttransition: all 0.3s ease;\n\tbox-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n\tz-index: 9997;\n\tfont-family: \"Inter\", sans-serif;\n\tmin-width: 200px;\n\tdisplay: block;\n\tfont-size: 16px;\n\tfont-weight: 600;\n\n\t&:hover {\n\t\ttransform: translateY(-2px);\n\t\tbox-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);\n\t\tbackground: #34495e;\n\t}\n\n\t&:active {\n\t\ttransform: translateY(0);\n\t}\n\n\t.button-content {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tgap: 12px;\n\t}\n\n\t.avatar-container-chat-button {\n\t\tposition: relative;\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tborder-radius: 50%;\n\t\toverflow: hidden;\n\t\tbackground: white;\n\n\t\t.avatar {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\n\t\t.status-badge {\n\t\t\tposition: absolute;\n\t\t\tbottom: -2px;\n\t\t\tright: -2px;\n\t\t\tbackground-color: #28a745;\n\t\t\tborder: 2px solid #2c3e50;\n\t\t\tborder-radius: 10px;\n\t\t\tpadding: 1px 6px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tbox-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n\t\t\tspan {\n\t\t\t\tcolor: white;\n\t\t\t\tfont-size: 8px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tletter-spacing: 0.5px;\n\t\t\t\tline-height: 1;\n\t\t\t\ttext-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n\t\t\t}\n\t\t}\n\t}\n\n\t.button-text {\n\t\tcolor: white;\n\t\tfont-size: 15px;\n\t\tfont-weight: 700;\n\t\twhite-space: nowrap;\n\t}\n}\n\n@media (max-width: $mobile_breakpoint) {\n\t.chat-button {\n\t\tbottom: 130px;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\twidth: calc(100% - 130px);\n\t\t//max-width: 400px;\n\t\tpadding: 10px 24px 10px 10px;\n\n\t\t&:hover {\n\t\t\ttransform: translateX(-50%) translateY(-2px);\n\t\t}\n\n\t\t&:active {\n\t\t\ttransform: translateX(-50%) translateY(0);\n\t\t}\n\n\t\t.avatar-container {\n\t\t\twidth: 36px;\n\t\t\theight: 36px;\n\t\t}\n\n\t\t.button-text {\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 700;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
